import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Tour from 'reactour';

import CreateShcedule from './CreateSchedule';

class TourGuideSchedule extends Component {
  constructor() {
    super();
    this.state = {
      isTourOpen: false,
      isShowingMore: false,
    };
  }

  toggleShowMore = () => {
    this.setState(prevState => ({
      isShowingMore: !prevState.isShowingMore,
    }));
  };

  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  render() {
    const { isTourOpen, isShowingMore } = this.state;
    const accentColor = '#537ccd';

    return (
      <div>
        <CreateShcedule
          openTour={this.openTour}
          closeTour={this.closeTour}
          toggleShowMore={this.toggleShowMore}
          isShowingMore={isShowingMore}
          history={this.props.history}
        />
        <Tour
          onRequestClose={this.closeTour}
          steps={tourConfig}
          isOpen={isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={5}
          accentColor={accentColor}
        />
      </div>
    );
  }
}

const tourConfig = [
  {
    selector: '[data-tut="reactour__descrever"]',
    content: 'Descreva a escala de trabalho',
  },
  {
    selector: '[data-tut="reactour__proximo"]',
    content: 'clique aqui para seguir adiante',
  },
  {
    selector: '[data-tut="reactour__cadastrar"]',
    content: 'Em cadastrar forneça os dias e os horários',
  },
  {
    selector: '[data-tut="reactour_irFuncionarios"]',
    content: 
  <React.Fragment>
    Acesse nosso blog para saber mais
    <Button
      href="https://blog.puntu.digital/post-first-steps/"
      color="primary"
    >
     Ver passo a passo
    </Button>
  </React.Fragment>
  },
];

export default TourGuideSchedule;